module.exports = __webpack_public_path__ + "img/8698b29.png";